import React, { useState, useEffect, useContext } from "react";
import NavPatient from "../../patients/navPatien/NavPatient";
import icon__search from "../../../asset/icon/search.svg";
import { TrashIcon } from "@heroicons/react/24/outline";
import Pagination from "../../pagination/Pagination";
import styles from "./TableQuestionnaire.module.css";
import moment from "moment/moment";
import PageHeader from "../../pageheader/PageHeader";
import * as patientApi from "../../../service/patientApiDev";
import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../../RedirectCode400";
import { CurrentUserContext } from "../../../App";

import DataTable from "react-data-table-component";
import HeadBar from "../headBar/HeadBar";
const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

function QuestionnairePatient() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);

  const [date, setDate] = useState("");

  const [valueSearch, setValueSearch] = useState("");
  const [submitSeatch, setSubmitSearch] = useState("");
  const [questionnaireList, setQuestionnaireList] = useState([]);
  // const [questionnaireListStorage, setQuestionnaireListStorage] = useState([])

  useEffect(() => {
    setDate(moment().add(543, "years").format("DD MMMM YYYY"));
  }, []);

  useEffect(() => {
    getQuestionnaire();
  }, [page]);

  const getQuestionnaire = async () => {
    setLoading(true);
    let res = await patientApi.getQuestionnaire(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setQuestionnaireList(res["data"]["questionnaire_list"]);
        // setQuestionnaireListStorage(res['data']['questionnaire_list'])
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const onClickSearchDataTable = ({ value }) => {
    // if (valueSearch !== '') {
    //     const filterTableSearch = questionnaireList.filter((item) => {
    //         return item['title']?.toLowerCase().includes(valueSearch?.toLowerCase())
    //     })
    //     setQuestionnaireList(filterTableSearch)
    // } else {
    //     setQuestionnaireList(questionnaireListStorage)
    // }
    setSubmitSearch(value);
  };

  const columnsQuestionnaireList = [
    {
      name: "ลำดับที่",
      selector: (i, idx) => <div>{idx + 1}</div>,
      width: "20%",
    },
    {
      name: "หัวข้อแบบสอบถาม",
      selector: (i) => (
        <div
          className="hover:bg-[#fff8f5] cursor-pointer text-[#000000] text-left text-[#526F65]"
          onClick={() => {
            window.open(i["url"]);
          }}
        >
          {i["title"]}
        </div>
      ),
      wrap: true,
    },
    // {
    //     name: 'เพิ่มเติม',
    //     selector: i => <div>
    //         <div className='flex justify-center'>
    //             <TrashIcon onClick={() => { setIsMessage({ type: 'error', data: 'ไม่สามารถใช้งานได้'}) }} className='w-6 stroke-[#E4642A] hover:cursor-pointer' />
    //         </div>
    //     </div>,
    //     width: '20%'
    // },
  ];

  return (
    <div className="global-page">
      <HeadBar />
      <PageHeader titlename={"แบบสอบถาม"} />
      <div>
        <div className="flex items-stretch md:flex-col gap-3">
          <div className="text-xl">รายการแบบสอบถามทั้งหมด</div>
          <div className="text-[#000000] self-center lg:self-start md:text-sm">{`(ข้อมูลวันที่ ${date})`}</div>
        </div>
        <div className="text-[#000000] mt-2 mb-2">{`จำนวน ${questionnaireList.length} หัวข้อ`}</div>

        <div className="flex items-center justify-start mb-4">
          <div className="flex sm:grid sm:grid-cols-1 gap-4 w-5/12 sm:w-full">
            <input
              disabledLabel
              className="border-2 border-solid border-[#A2B5BC] rounded-lg text-state-100 text-[#000000] px-4"
              placeholder="ค้นหาด้วยชื่อ"
              value={valueSearch}
              onChange={(e) => {
                setValueSearch(e.target.value);
              }}
            ></input>

            <button
              className="button-theme-pg flex justify-center items-center w-28 h-10 md:h-6 bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl gap-1 shadow-sm shadow-brand-cyan"
              onClick={() => {
                onClickSearchDataTable({
                  value: valueSearch,
                });
              }}
            >
              <img className="stroke-[#526F65] w-4" src={icon__search} alt="" />
              <div className="text-sm text-[#000000]">ค้นหา</div>
            </button>
          </div>
        </div>

        <div className={styles.align}>
          <DataTable
            className="classTable"
            columns={columnsQuestionnaireList}
            data={questionnaireList.filter((search) => {
              return search["title"]
                ?.toLowerCase()
                .includes(submitSeatch?.toLowerCase());
            })}
            customStyles={customStyles}
            noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
          />
        </div>
        <Pagination
          page={page}
          totalpage={maxPage}
          clickForward={() => {
            if (page < maxPage) {
              setPage(page + 1);
            }
          }}
          clickBackward={() => {
            if (page > 1) {
              setPage(page - 1);
            }
          }}
        />
      </div>
    </div>
  );
}

export default QuestionnairePatient;
